import React from 'react'

export default ({ text, subText }) => (
    <div className="chartMessageWrapper">
        <div className="chartMessageText">
            {text}
        </div>
        {subText ? <div className="chartMessageSubtext">{subText}</div> : null}
    </div>
)